import request from '@/utils/request'

// -------------------- /buss/market/ --------------------

// 首页欢迎词
export function welcomeText() {
    return request({
        url: '/buss/market/info/prompt',
        method: 'get',
    })
}

// 查询交易日
export function isTradingDay() {
    return request({
        url: '/buss/market/check/a',
        method: 'get'
    })
}

// 交易日历
export function getDealDate() {
    return request({
        url: '/buss/market/trading/calendar',
        method: 'get'
    })
}

// -------------------- /buss/navigationMenu/ --------------------

// 获取导航栏路由
export function getRouters() {
    return request({
        url: '/buss/navigationMenu/tree',
        method: 'get',
    })
}

// -------------------- /buss/industry/ --------------------

// 行业资讯
export function getIndustryMessage() {
    return request({
        url: '/buss/industry/info/list',
        method: 'get',
    })
}

// 行业资讯-类别查询
export function getIndustryType(query) {
    return request({
        url: '/buss/industry/info/type/list',
        method: 'get',
        params: query
    })
}

// 行业资讯-全部查询/按类别查询
export function getIndustryList(query) {
    return request({
        url: '/buss/industry/info/list',
        method: 'get',
        params: query
    })
}

// 行业资讯-按类型分页查询
export function getIndustryPagingList(query) {
    return request({
        url: '/buss/industry/info/page',
        method: 'get',
        params: query
    })
}

// 行业资讯文章详情
export function getIndustryDetail(financeId) {
    return request({
        url: '/buss/industry/info/detail/' + financeId,
        method: 'get'
    })
}

// -------------------- /buss/supply/chain/finance/ --------------------

// 供应链服务-分页查询
export function getSupplyFinancePaging(query) {
    return request({
        url: '/buss/supply/chain/finance/page',
        method: 'get',
        params: query
    })
}

// 供应链文章详情
export function getFinanceDetail(financeId) {
    return request({
        url: '/buss/supply/chain/finance/detail/' + financeId,
        method: 'get'
    })
}

// -------------------- /buss/platform/college/ --------------------

// 平台学院-类别查询
export function getSchoolType(query) {
    return request({
        url: '/buss/platform/college/type/list',
        method: 'get',
        params: query
    })
}

// 平台学院-全部查询/按类别查询
export function getSchoolList(query) {
    return request({
        url: '/buss/platform/college/info/list',
        method: 'get',
        params: query
    })
}

// 平台学院-按类型分页查询
export function getSchoolPagingList(query) {
    return request({
        url: '/buss/platform/college/info/page',
        method: 'get',
        params: query
    })
}

// 平台学院文章详情
export function getSchoolDetail(financeId) {
    return request({
        url: '/buss/platform/college/info/detail/' + financeId,
        method: 'get'
    })
}

// -------------------- /buss/notice/ --------------------

// 分页查询公告发布信息
export function getNoticeInfo(query) {
    return request({
        url: '/buss/notice/info/page',
        method: 'get',
        params: query
    })
}

// -------------------- /buss/intelligent/ --------------------

// 查询知识类型
export function issueListType() {
    return request({
        url: '/buss/intelligent/customer/tree',
        method: 'get',
    })
}

export function issueListChildren(id) {
    return request({
        url: '/buss/intelligent/customer/' + id,
        method: 'get'
    })
}

// -------------------- /buss/supply/guarantee/ --------------------

// 保供专区-分页查询列表
export function pagesProvide_Unit(params) {
    return request({
        url: '/buss/supply/guarantee/zone/page',
        method: 'get',
        params
    })
}

// 保供专区-查询详情
export function detailProvide_Unit(id) {
    return request({
        url: '/buss/supply/guarantee/zone/detail/' + id,
        method: 'get'
    })
}

// -------------------- /buss/insurance/ --------------------

// 保险品牌列表
export function listInsuranceBrand(params) {
    return request({
        url: '/buss/insurance/company/info/list',
        method: 'get',
        params
    })
}

// 分页查询保险产品
export function pagesInsuranceProduct(params) {
    return request({
        url: '/buss/insurance/management/info/page',
        method: 'get',
        params
    })
}

// 查询保险产品详情
export function detailInsuranceProduct(id) {
    return request({
        url: '/buss/insurance/management/info/details/' + id,
        method: 'get'
    })
}

// 提交投保资讯信息
export function addInformationInfo(data) {
    return request({
        url: '/buss/insurance/management/info/consultation/add',
        method: 'post',
        data
    })
}

// -------------------- /buss/company/ --------------------

// 查询牧草联盟联盟信息
export function allianceInfos() {
    return request({
        url: '/buss/company/unit/info/alliance/query',
        method: 'get'
    })
}

// 查询牧草联盟会长副会长列表
export function allianceAdminList() {
    return request({
        url: '/buss/company/unit/info/list',
        method: 'get'
    })
}

// 查询牧草联盟会员列表
export function allianceUnitList(params) {
    return request({
        url: '/buss/company/unit/info/member/unit/page',
        method: 'get',
        params
    })
}
